/* eslint-disable jsx-a11y/alt-text */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Utility from "../utility/utility";
import { landingLogo } from "../assets";

const Home = () => {
  const navigate = useNavigate();

  const gameData = useSelector(
    (state) => state.joinReducer.data
  );

  useEffect(() => {
    Utility.isSignedIn(gameData).then((value) => {
      if (value) {
        navigate("/gameboard");
      }
    });
  }, [gameData]);

  return (
    <>
      <div className="background">
        <div className="container">
          <div className="d-flex flex-column min-vh-100 justify-content-center align-items-center">
            <div className="text-center">
              <img src={landingLogo} className="width-set-home" />
            </div>
            <div className="text-center button-home-top">
              <button
                onClick={() => {
                  localStorage.clear();
                  sessionStorage.clear();
                  navigate("/role-selection"); // Changed from "/room" to "/role-selection"
                }}
                type="button"
                className="btn border-home-button semi-bold"
              >
                Start
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
